<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('user_group') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/setting/group" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <b-table :busy="isLoading" :fields="columns" :items="records" show-empty hover class="table-sm no-bor">
                        <template #table-busy>
                            <div class="text-center my-2"><b-spinner variant="info" class="align-middle"></b-spinner></div>
                        </template>
                        <template v-slot:cell(No)="row">{{(row.index + 1)}}</template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Text: ''
                },
                isLoading: false,
                records:[],
                columns: [
                    { key: 'No', class: 'wd-no' },
                    { key: 'Name', label: this.$t('group_name') },
                    { key: 'ClientName' },
                    { key: 'CompanyName' },
                    { key: 'Sort' }
                ]
            }
        },
        created() {
            this.toList();
        },
        methods: {
            toList(){
                this.isLoading = true;
                this.query.CompanyId = this.$store.state.auth.CompanyId;
                this.$api().post('user/groups', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Groups;
                    }
                }).finally(() => { this.isLoading = false; });
            }
        }
    }
</script>